import { render, staticRenderFns } from "./BasMeasureUnitList.vue?vue&type=template&id=594d7298&scoped=true&"
import script from "./BasMeasureUnitList.vue?vue&type=script&lang=js&"
export * from "./BasMeasureUnitList.vue?vue&type=script&lang=js&"
import style0 from "./BasMeasureUnitList.vue?vue&type=style&index=0&id=594d7298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d7298",
  null
  
)

export default component.exports